'use strict';

var processInclude = require('./util');

$(document).ready(function () {
    processInclude(require('./cart/cart'));
    processInclude(require('./cart/favorite'));
    processInclude(require('./product/salesCounter'));
});
